/**
 * Converts a query object into a query param string.
 * Does not include leading '?'.
 * @example encodeSearchParams({ tab: 'foo', mode: 'bar' }) => 'tab=foo&mode=bar'
 */
export function encodeSearchParams<
  T extends Record<string, string | number | boolean | undefined>,
>(queries?: T): string {
  let result = '';
  if (queries) {
    for (const [key, value] of Object.entries(queries)) {
      if (value === undefined) {
        continue;
      }
      if (result.length > 0) {
        result += '&';
      }
      if (value === '') {
        result += encodeURIComponent(key);
      } else {
        result += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }
    }
  }
  return result;
}
